import { createBrowserRouter, RouterProvider } from 'react-router'
import Layout from '@/routes/_layout'
import IndexPage from '@/routes/index'
import LoginPage from '@/routes/login'
import AuthCallbackPage from '@/routes/auth-callback'
import WishlistPage from '@/routes/wishlist'
import PlayingPage from '@/routes/playing'
import PlayingV2Page from '@/routes/playing-v2'
import PlayedPage from '@/routes/played'
import CommonLibraryPage from '@/routes/common-library'
import RecommendationsPage from '@/routes/recommendations'
import BrowsePage from '@/routes/browse'
import LibraryPage from '@/routes/library'
import FriendsPage from '@/routes/friends'

const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/callback',
    element: <AuthCallbackPage />,
  },
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <IndexPage /> },
      { path: 'wishlist',    element: <WishlistPage /> },
      { path: 'playing',     element: <PlayingPage /> },
      { path: 'playing-v2',  element: <PlayingV2Page /> },
      { path: 'played',      element: <PlayedPage /> },
      { path: 'common-library', element: <CommonLibraryPage /> },
      { path: 'recs',        element: <RecommendationsPage /> },
      { path: 'browse',      element: <BrowsePage /> },
      { path: 'library',     element: <LibraryPage /> },
      { path: 'friends',     element: <FriendsPage /> },
    ],
  },
])

export default function App() {
  return <RouterProvider router={router} />
}
